define(['jquery'], function ($) {
    function ErgoTriggers() {
        this.init = function () {
            this.bindEvents();
        };

        this.handleTopMenuSectionClick = function ($currentList, wasExpanded) {
            $('.top-menu-sections > .link-list').each(function () {
                const $list = $(this);
                $list.removeClass('is-expanded')
                    .find('.sub-list').removeClass('fade-in')
                    .end()
                    .find('.link-list').removeClass('is-expanded')
                    .find('.level-one').removeClass('fade-in');
            });

            if (!wasExpanded) {
                $currentList.addClass('is-expanded')
                    .find('> .sub-list').addClass('fade-in');
            }
        };

        this.handleSubListClick = function ($currentList) {
            $currentList.toggleClass('is-expanded')
                .find('> .level-one').toggleClass('fade-in');
        };

        this.navigateToHref = function ($header) {
            const href = $header.find('span').data('href');
            if (href && href !== '#') {
                window.location.href = href;
            }
        };

        this.bindEvents = function () {
            const self = this;

            $('.link-list__header').on('click', function (e) {
                const $header = $(this);
                const isArrowClick = e.offsetX > $header.width() - 30;
                const $currentList = $header.closest('.link-list');
                const isInTopMenuSections = $header.closest('.top-menu-sections').length &&
                    $header.parent().parent().hasClass('top-menu-sections');
                const isInSubListWrapper = $header.closest('.sub-list__inner-wrapper').length;
                const isInLevelOne = $header.closest('.level-one').length;

                if ($header.hasClass('arrow') && isArrowClick) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (isInTopMenuSections) {
                        const wasExpanded = $currentList.hasClass('is-expanded');
                        self.handleTopMenuSectionClick($currentList, wasExpanded);
                    } else if (isInSubListWrapper) {
                        self.handleSubListClick($currentList);
                    }
                } else {
                    const shouldToggleExpand = isInSubListWrapper && !isInLevelOne;

                    if (shouldToggleExpand) {
                        self.handleSubListClick($currentList);
                    }

                    if (!shouldToggleExpand) {
                        self.navigateToHref($header);
                    }
                }
            });
        };
    }

    $(document).ready(function () {
        const mobileTopMenu = new ErgoTriggers();
        mobileTopMenu.init();
    });

    return ErgoTriggers;
});